///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2026
//                                    RXO Inc.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of RXO Inc. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////


import React from "react";
import { useHistory } from "react-router-dom";
import { format } from "date-fns";
import { dateFormat, division as userDivision } from "../../helpers/types";
import getStatusColor from "../../helpers/getStatusColor";
import redirectToBid from "../../helpers/redirectToBid";

const BodyCell = ({ value, children, maxWidth }) => (
  <td
    className="body-cell py-16 px-8 align-middle"
    style={{ maxWidth: maxWidth }}
  >
    {value || children}
  </td>
);

function TableBody({ bids, division }) {
  const history = useHistory();

  return (
    <tbody data-testid="table-body">
      {bids.map(bid => {
        const statusColor = getStatusColor(bid.status);
        const bidDateFormat =
          division === userDivision.coy ? dateFormat.MMddyy : dateFormat.ddMMyy;

        return (
          <tr
            className="row bg-white"
            key={bid.bidId}
            onClick={e => redirectToBid(e, bid.bidId, history)}
          >
            <BodyCell value={bid.bidName} maxWidth="150px" />
            <BodyCell value={bid.createByUserName} maxWidth="126px" />
            <BodyCell value={bid.bidOwners} maxWidth="132px" />
            <BodyCell value={bid.shipperName} maxWidth="132px" />
            <BodyCell
              value={format(new Date(bid.startDateUTC + "Z"), bidDateFormat)}
              maxWidth="94px"
            />
            <BodyCell
              value={format(new Date(bid.endDateUTC + "Z"), bidDateFormat)}
              maxWidth="87px"
            />
            <BodyCell value={bid.modeNames} maxWidth="92px" />
            <BodyCell maxWidth="104px">
              <div className="flex items-center">
                <p
                  style={{ backgroundColor: statusColor }}
                  className="status inline-block mb-0 mr-6"
                ></p>
                {bid.status}
              </div>
            </BodyCell>
          </tr>
        );
      })}
    </tbody>
  );
}

export default TableBody;
